import { useEffect, useState } from 'react';
import Button from './ui/Button';
import useCalendly from '../hooks/useCalendly';

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const { open } = useCalendly();

  useEffect(() => {
    function handleScroll() {
      const hero = document.getElementById('hero');
      const heroRect = hero ? hero.getBoundingClientRect() : null;
      const heroFullyInView = heroRect ? heroRect.top >= 0 && heroRect.bottom <= window.innerHeight : false;
      const footer = document.getElementById('site-footer');
      const footerRect = footer ? footer.getBoundingClientRect() : null;
      const overlapsFooter = footerRect ? footerRect.top < window.innerHeight : false;
      const shouldShow = window.scrollY > 200 && !heroFullyInView && !overlapsFooter;
      setVisible(shouldShow);
    }

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-4 z-40 mx-auto w-full max-w-md px-4 sm:hidden">
      <div className="rounded-full bg-white px-2 py-2 shadow-lg ring-1 ring-cam-blue/20">
        <Button variant="primary" className="w-full focus:ring-offset-white" type="button" onClick={() => open()}>
          Schedule a Call
        </Button>
      </div>
    </div>
  );
}
